export const getOfferState = (statusIndex, index) => {
    if (statusIndex === -1) {
        return 'complete';
    }
    if (index < statusIndex) {
        return 'complete';
    }
    if (index === statusIndex) {
        return 'active';
    }
    return 'inactive';
};
